module.exports = __webpack_public_path__ + "media/groms-bank.6928d466.mp3";